import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {}

export function Container(props: Readonly<Props>) {
  return (
    <div className="container mx-auto max-w-(--breakpoint-xl) space-y-6 flex flex-col px-4 sm:pt-0 pt-2">
      {props.children}
    </div>
  );
}
